import EditorTool from './editor-tool.vue'
export default EditorTool
